import React, { useRef } from 'react'
import Slider from "react-slick";
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from '@gsap/react';

import videosource from "../assets/video/haus-home-sequence.webm";
import techstars from "../assets/img/techstars.png";
import sqbventures from "../assets/img/sqb_ventures.svg";
import uzum from "../assets/img/uzum.png";
import fao from "../assets/img/fao.png";
import undp from "../assets/img/undp.png";
import ebrd from "../assets/img/ebrd.png";
import cgiar from "../assets/img/cgiar.png";
import kursiv from "../assets/img/kursiv.png";
import hackathon1 from "../assets/img/hackathon_1.jpg";
import techstarsuzvc from "../assets/img/techstars.jpg";
import additionalServices1 from "../assets/img/additional_services.jpg";
import acceleration1 from "../assets/img/acceleration.webp";
import tigran from "../assets/img/tigran.jpg";
import ansora from "../assets/img/ansora.jpg";
import dimadina from "../assets/img/team/dimadina2.jpg";
import mahtob from "../assets/img/team/mahtob.jpg";
import aziza from "../assets/img/team/aziza.jpg";
import mmadina from "../assets/img/team/mmadina.jpg";
import asilbek from "../assets/img/team/asilbek.jpg";
import abdullo from "../assets/img/team/abdullo.jpg";
import shams from "../assets/img/team/shams.jpg";
import sarvar from "../assets/img/team/sarvar.jpg";
import munisa from "../assets/img/team/munisa.jpg";
import customTransition from '../utils/transition';
import Header from '../components/Header';
import { Link } from 'react-router-dom';
import { cases } from '../App';

var settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
};

var companiesSliderSettings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    autoplaySpeed: 3000,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
    ],
};

const testimonals = [
    {
        text: "Collaborating with SWT Community has been a valuable partnership for us. It has made a significant contribution to the development of Alif Tech's HR brand and the establishment of long-term talent management. We highly value the community's contribution to shaping the startup ecosystem in the country and are pleased to be part of this journey.",
        author: {
            name: "Ansora Bilolova",
            position: "Head of IT HR at Alif Uzbekistan",
            avatar: ansora,
        },
    },
    {
        text: "Working with Hackonnect is a results-driven approach. They deliver turnkey solutions, quickly adapting to the bank's needs. The results speak for themselves: nearly 1,000 participants have been attracted, and our portfolio has expanded with high-quality projects and IP. The team's flexibility and professionalism are top-notch.",
        author: {
            name: "Tigran Bekmullin",
            position: "CEO at SQB Ventures",
            avatar: tigran,
        },
    },
];

const teamMembers = [
    {
        name: "Madina Zokirova",
        position: "CEO & Co-founder (ex-IT Park, ex-Ministry of Agriculture, 10 programs behind)",
        avatar: dimadina,
    },
    {
        name: "Azizakhon Xamdamova",
        position: "CSO (ex-Plug and Play, Tasnet, FCB Artgroup, Nestle Uzbekistan)",
        avatar: aziza,
    },
    {
        name: "Mahtob Asadova",
        position: "Co-founder (MohirAI, Coca-Cola Uzbekistan)",
        avatar: mahtob,
    },
    {
        name: "Madina Mirzakhalilova",
        position: "Program Manager (Fintech Association of Uzbekistan, ex-Billz, Enter Engineering Group)",
        avatar: mmadina,
    },
    {
        name: "Asilbek Ortikov",
        position: "CMO (ex-Korzinka, CodiPlay, ISIC)",
        avatar: asilbek,
    },
    {
        name: "Abdullo Zokirov",
        position: "Logistician (Sahna Standup, 10+ concerts behind)",
        avatar: abdullo,
    },
    {
        name: "Shamsiddin Abdurakhimov",
        position: "Designer",
        avatar: shams,
    },
    {
        name: "Sarvar Mutalov",
        position: "CTO (ex-EPAM Systems)",
        avatar: sarvar,
    },
    {
        name: "Munisa Bakaeva",
        position: "SMM Specialist",
        avatar: munisa,
    },
]

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function Home() {
    const container = useRef();

    // useGSAP(
    //     () => {
    //         let mm = gsap.matchMedia();

    //         mm.add("(min-width: 768px)", () => {

    //             gsap.set(".hover-block img", {
    //                 x: "50%",
    //                 y: "50%",
    //                 xPercent: -50,
    //                 yPercent: -50,
    //             });

    //             let activeImage;
    //             gsap.utils.toArray(".hover-block").forEach((el) => {
    //                 let image = el.querySelector("img"),
    //                     setX,
    //                     setY,
    //                     align = (e) => {
    //                         setX(e.clientX);
    //                         setY(e.clientY);
    //                     },
    //                     startFollow = () => document.addEventListener("mousemove", align),
    //                     stopFollow = () => document.removeEventListener("mousemove", align),
    //                     fade = gsap.to(image, {
    //                         autoAlpha: 1,
    //                         ease: "none",
    //                         paused: true,
    //                         duration: 0.2,
    //                         onReverseComplete: stopFollow,
    //                     });

    //                 el.addEventListener("mouseenter", (e) => {
    //                     fade.play();
    //                     startFollow();
    //                     if (activeImage) {
    //                         gsap.set(image, {
    //                             x: gsap.getProperty(activeImage, "x"),
    //                             y: gsap.getProperty(activeImage, "y"),
    //                         });
    //                     }
    //                     activeImage = image;
    //                     setX = gsap.quickTo(image, "x", { duration: 0.6, ease: "power3" });
    //                     setY = gsap.quickTo(image, "y", { duration: 0.6, ease: "power3" });
    //                     align(e);
    //                 });

    //                 el.addEventListener("mouseleave", () => fade.reverse());
    //             });

    //             return () => {
    //             };
    //         });


    //     },
    //     { scope: container }
    // );

    return (
        <div>
            <Header
                main={
                    <>
                        <div>Powering</div>
                        <div>
                            <span className="purple">connections</span>
                        </div>
                        <div className="">
                            Sparking <span className="blue">actions</span>
                        </div>
                    </>
                }
                action={
                    <Link to="/contact" className="btn primary">
                        start a project
                    </Link>
                }
                bottom={
                    <>
                        Hackonnect — program management company specializing in hackathons, incubation, and acceleration programs. It focuses on building communities and bottom-up startup ecosystem activities for founders in Central Asia.
                    </>
                }
            />
            <main ref={container}>
                <section id="about" data-color="white black">
                    <div className="container">
                        <div className="split-row px-xl">
                            <div>
                                <video width="750" muted autoPlay loop>
                                    <source src={videosource} type="video/mp4" />
                                </video>
                            </div>
                            <div>
                                <h2>
                                    Hackonnect - Igniting{" "}
                                    <span className="bg-rounded bg-blue">Creativity</span> in the
                                    IT World
                                </h2>
                                <div className="split-content">
                                    <p>
                                        We believe that by connecting talented individuals and
                                        organizations through exceptional IT event management, we
                                        can unlock the potential to tackle real-world challenges and
                                        propel groundbreaking ideas forward.
                                        <br />
                                        <br />
                                        <b>Our Mission:</b>
                                        <br />
                                        Fostering a collaborative ecosystem where disruptive ideas meet the resources and relationships needed to drive meaningful results.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-color="black white">
                    <div className="container">
                        <div className="split-row split-row-head align-items-end">
                            <div className="half-row">
                                {/* <div></div> */}
                                {/* <div>Services</div> */}
                            </div>
                            <div>
                                <h2>What we do:</h2>
                            </div>
                        </div>
                        <div className="service-block split-row">
                            <div>
                                <h3>Techstars Uzbekistan</h3>
                                <div className="">
                                    <img src={techstarsuzvc} alt="techstarsuzvc" />
                                </div>
                            </div>
                            <div className="split-content">
                                <h3>
                                    Official Execution & Program Delivery
                                </h3>
                                <ul>
                                    <li>Our volunteering since 2018, featuring 54-hour hackathons launching MVPs attracted Techstars officially and what we offer:</li>

                                    <li><b>Startup Weekend (54 hours):</b> Build an MVP and a team in just one weekend.</li>

                                    <li><b>Founder Catalyst (10 weeks):</b> A virtual pre-accelerator for those ready for serious growth and first investments.</li>

                                    <li><b>Startup Week & Community Lab:</b> Direct access to connections and mentors from Central Asia, the USA, Europe, and the CIS.</li>

                                    <li><b>Startup Digest:</b> Newsletter featuring the best startup events, initiatives, and opportunities.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="service-block split-row">
                            <div>
                                <h3>Hackathon Organization</h3>
                                <div className="">
                                    <img src={hackathon1} alt="hackathon" />
                                </div>
                            </div>
                            <div className="split-content">
                                <h3>
                                    We excel in organizing hackathons across various IT
                                    specializations, including:
                                </h3>
                                <ul>
                                    <li>We organize hackathons across the IT spectrum, including:</li>
                                    <li><b>Web & Mobile:</b> Building digital products fast.</li>
                                    <li><b>Cybersecurity:</b> Protecting data and systems.</li>
                                    <li><b>AI & Data Science:</b> Turning data into solutions.</li>
                                    <li><b>Blockchain:</b> Developing secure, modern tech.</li>
                                    <li><b>Open Innovation:</b> Solving your specific business challenges.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="service-block split-row">
                            <div>
                                <h3>Acceleration & Incubation Programs</h3>
                                <div className="">
                                    <img src={acceleration1} alt="hackathon" />
                                </div>
                            </div>
                            <div className="split-content">
                                <h3>
                                    We design and manage programs tailored to IT startups,
                                    providing them with resources specific to their needs:
                                </h3>
                                <ul>
                                    <li>
                                        <b>Pre-Seed Acceleration:</b> Equip early-stage IT startups
                                        with the tools and network to validate their business ideas
                                        and secure initial funding.
                                    </li>
                                    <li>
                                        <b>Seed-Stage Incubation:</b> Offer dedicated workspace,
                                        mentorship, and investor connections to help IT startups
                                        develop their product or service and scale their business.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="service-block split-row">
                            <div>
                                <h3>Additional Services</h3>
                                <div className="">
                                    <img src={additionalServices1} alt="hackathon" />
                                </div>
                            </div>
                            <div className="split-content">
                                <h3>
                                    We offer a range of services to complement your IT event
                                    needs, including:
                                </h3>
                                <ul>
                                    <li>
                                        <b>Marketing & Event Branding:</b> Develop a strong brand
                                        identity and create targeted marketing campaigns to attract
                                        the right participants and sponsors for your IT event.
                                    </li>
                                    <li>
                                        <b>Logistics & Management:</b> Handle all aspects of event
                                        planning and execution, from venue sourcing to technology
                                        setup and post-event reporting.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section data-color="black white" style={{ marginTop: 50 }}>
                    <div className="container px-xl">
                        <h3>Our core values</h3>
                        <div className="infocards">
                            <div className="infocard">
                                <div className="infocard-head">01</div>
                                <div className="infocard-title">Passion</div>
                                <div className="infocard-description">
                                    We are driven by a genuine enthusiasm for fostering creativity and economic progress within the region.
                                </div>
                            </div>
                            <div className="infocard">
                                <div className="infocard-head">02</div>
                                <div className="infocard-title">Excellence</div>
                                <div className="infocard-description">
                                    We strive to deliver exceptional service and experience in everything we do.
                                </div>
                            </div>
                            <div className="infocard">
                                <div className="infocard-head">03</div>
                                <div className="infocard-title">Collaboration</div>
                                <div className="infocard-description">
                                    We believe that the power of collaboration is key to unlocking innovation and achieving success.
                                </div>
                            </div>
                            <div className="infocard">
                                <div className="infocard-head">04</div>
                                <div className="infocard-title">Community</div>
                                <div className="infocard-description">
                                    We are building a strong and supportive community around technology/advanced economics/business
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="team" data-color="white black">
                    <div className="container">
                        <div className="split-row split-row-head align-items-end">
                            <div className="half-row">
                                <div></div>
                                <div>
                                    <span className="helper-heading">Our Team</span>
                                </div>
                            </div>
                            <div>
                                <h2>
                                    Get to know <span className="bg-rounded bg-blue">people</span>{" "}
                                    that get it all done
                                </h2>
                            </div>
                        </div>
                        <div className="split-row align-items-end">
                            <div className="half-row"></div>
                            <div>
                                <div className="team-gallery">
                                    {
                                        teamMembers.map((member, index) => (
                                            <div key={index} className="team-gallery-item">
                                                <img src={member.avatar} alt={member.name} />
                                                <div>
                                                    <div>
                                                        <b>{member.name}</b>
                                                    </div>
                                                    <div>{member.position}</div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="partners" data-color="white black">
                    <div className="container">
                        <div className="split-row split-row-head align-items-end pt-xl">
                            <div className="half-row">
                                <div></div>
                                <div>
                                    <span className="helper-heading">Hackonnections</span>
                                </div>
                            </div>
                            <div>
                                <h2>We already worked with</h2>
                            </div>
                        </div>
                        <div>
                            <Slider
                                {...companiesSliderSettings}
                                className="companies-slider px-xl"
                            >
                                <div className="companies-slider-item">
                                    <img src={techstars} />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={sqbventures} />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={uzum} />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={fao} alt="fao" />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={ebrd} alt="ebrd" />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={cgiar} alt="cgiar" />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={undp} alt="undp" />
                                </div>
                                <div className="companies-slider-item">
                                    <img src={kursiv} alt="kursiv" />
                                </div>
                            </Slider>
                        </div>

                        <div className="split-row">
                            <div className="half-row">
                            </div>
                            <div className="split-content">
                                <div>
                                    <Slider
                                        {...settings}
                                        className="testimonal-slider"
                                    >
                                        {
                                            testimonals.map((item, index) => (
                                                <div key={index}>
                                                    <div>
                                                        <h4>
                                                        {item.text}
                                                    </h4>
                                                    <div className="testimonal-author-block">
                                                        <div className="testimonal-author-avatar">
                                                            <img src={item.author.avatar} alt="testimonal author" />
                                                        </div>
                                                        <div className="testimonal-author-description">
                                                            <div className="testimonal-author-name">
                                                                {item.author.name}
                                                            </div>
                                                            <div className="testimonal-author-position">
                                                                {item.author.position}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        }
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="team" data-color="white black">
                    <div className="container">
                        <div className="split-row split-row-head align-items-end">
                            <div className="half-row">
                                <div></div>
                                <div>
                                    <span className="helper-heading">Our Work</span>
                                </div>
                            </div>
                            <div>
                                <h2>Composing Stellar Moments</h2>
                            </div>
                        </div>
                    </div>
                    <div className="container wide">

                        <div>
                            <div className="work-gallery">
                                {
                                    cases.map((item, index) => (
                                        <Link to={item.path} key={index} className="work-gallery-item">
                                            <div className={`work-gallery-image ${index % 4 === 0 ? "bg-asterisk-blue" : index % 4 === 1 ? "bg-hc-pink" : index % 4 === 2 ? "bg-asterisk-pink" : "bg-hc-blue"}`}>
                                                <img src={item.meta.image} alt={item.meta.title} />
                                            </div>
                                            <div className="work-gallery-description">
                                                <span className="bg-rounded bg-blue">
                                                    {item.meta.title}
                                                </span>
                                            </div>
                                        </Link>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </section>
                <section data-color="white black">
                    <div className="container">
                        <div className="split-row align-items-end pt-xl">
                            <div className="half-row">
                                {/* <div>☼</div> */}
                                <div>
                                    {/* <span className="helper-heading">Contact Us</span> */}
                                </div>
                            </div>
                            <div>
                                <h2>
                                    Let's{" "}
                                    <span className="bg-rounded bg-blue">hackonnect</span>
                                </h2>
                            </div>
                        </div>
                        <div className="split-row">
                            <div className='half-row'></div>
                            <div>
                                <div className="split-content">
                                    <p>
                                        Contact Hackonnect today to discuss your IT event needs.
                                        Let's collaborate on creating a successful and impactful
                                        program that propels innovation forward.
                                    </p>
                                    <br />
                                    <Link to="/contact" className="btn">
                                        start a project
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="contacts" data-color="white black">
                    <div className="container">
                        <div className="split-row split-row-head align-items-end pt-xl">
                            <div className="half-row">
                                <div></div>
                                <div>Contact us</div>
                            </div>
                            <div>
                                <h2 className="">Get in Touch</h2>
                            </div>
                        </div>
                        <div className="split-row">
                            <div className='half-row'></div>
                            <div>
                                <div className="split-content">
                                    <h4>
                                        Have an event in mind? We’re here to help bring it to life.
                                    </h4>
                                    <br />
                                    <span>
                                        <b>
                                            <a href="mailto:hello@hackonnect.uz" className='email'>
                                                hello@hackonnect.uz
                                            </a>
                                        </b>
                                    </span>
                                    <br />
                                    <span>
                                        <b>
                                            <a href="tel:+998906390639" className='phone'>
                                                +998 90 639 06 39
                                            </a>
                                        </b>
                                    </span>
                                    <br />
                                    <br />
                                    <div>
                                        Your vision, our expertise—let’s create something
                                        extraordinary together.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default customTransition(Home);